import {
  LOCIZE_LOGIN_TRANSLATION_KEYS,
  LocizeNamespaces,
  STEP_COUNTER_COMPONENT_ID,
} from 'app-constants';
import { DisplayStyles } from 'models';
import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setElementDisplayById } from 'services';

interface PendingViewProps {
  containerClassName?: string;
  paragraphClassName?: string;
}

export const PendingView = ({
  containerClassName,
  paragraphClassName,
}: PendingViewProps) => {
  const { t } = useTranslation(LocizeNamespaces.login);

  useLayoutEffect(() => {
    setElementDisplayById(STEP_COUNTER_COMPONENT_ID, DisplayStyles.none);
    return () => {
      setElementDisplayById(STEP_COUNTER_COMPONENT_ID, DisplayStyles.flex);
    };
  });

  return (
    <div className={containerClassName}>
      <p className={paragraphClassName}>
        {t(LOCIZE_LOGIN_TRANSLATION_KEYS.loginConfirmationProcessingDisclaimer)}
      </p>
      <p className={paragraphClassName}>
        {t(LOCIZE_LOGIN_TRANSLATION_KEYS.customerAwaitingLoginLinkDisclaimer)}
      </p>
      <p className={paragraphClassName}>
        {t(LOCIZE_LOGIN_TRANSLATION_KEYS.customerAwaitingPatienceDisclaimer)}
      </p>
    </div>
  );
};
